import React, { lazy, Suspense, forwardRef } from 'react'

const Lazy = lazy(() =>
    import('./sync').catch((error) => {
        console.log('[APP] Component Failed Loading:', error)
        return { default: () => <div /> }
    })
)

const LazyWrapper = forwardRef((props, ref) => {
    return (
        <Suspense fallback={<div></div>}>
            <Lazy ref={ref} {...props} />
        </Suspense>
    )
})

export default LazyWrapper
